module.exports = __webpack_public_path__ + "static/media/avatar-24.69a7e64e.svg";